import { SearchIcon, TimerIcon, SettingsIcon, BugIcon } from "../icons";

interface HeaderBarProps {
  readonly onSearch: () => void;
  readonly onSettings?: () => void;
  readonly onBugReport?: () => void;
  readonly pomodoroActive?: boolean;
  readonly pomodoroTimeLeft?: number;
  readonly hasTimers?: boolean;
  readonly anyTimerRunning?: boolean;
  readonly runningTimerCount?: number;
  readonly onTimerToggle?: () => void;
  readonly sidebarPinned?: boolean;
}

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export function HeaderBar({
  onSearch,
  onSettings,
  onBugReport,
  pomodoroActive,
  pomodoroTimeLeft,
  hasTimers,
  anyTimerRunning,
  runningTimerCount = 0,
  onTimerToggle,
  sidebarPinned,
}: HeaderBarProps) {
  return (
    <header className="sticky top-0 z-20 bg-surface/95 backdrop-blur-sm border-b border-border pt-[env(safe-area-inset-top)]">
      <div className="flex items-center justify-between px-4 h-10">
        {/* Title */}
        <h1 className={`text-base font-bold text-ink ${sidebarPinned ? "md:hidden" : ""}`}>Palnia</h1>

        {/* Actions */}
        <div className="flex items-center gap-1 ml-auto">
          {pomodoroActive && pomodoroTimeLeft !== undefined && (
            <div className="text-accent text-xs font-mono bg-accent/10 px-2 py-1 rounded-lg">
              {formatTime(pomodoroTimeLeft)}
            </div>
          )}

          {hasTimers && onTimerToggle && (
            <button
              type="button"
              onClick={onTimerToggle}
              aria-label="Ouvrir les timers"
              className={`xl:hidden min-w-8 min-h-8 flex items-center justify-center gap-1 rounded-lg transition-colors ${
                anyTimerRunning
                  ? "text-accent bg-accent/10"
                  : "text-ink-muted hover:text-ink hover:bg-surface-alt"
              }`}
            >
              <TimerIcon />
              {runningTimerCount > 0 && (
                <span className="text-[10px] font-bold text-accent tabular-nums">
                  {runningTimerCount}
                </span>
              )}
            </button>
          )}

          <button
            onClick={onSearch}
            className="min-w-8 min-h-8 flex items-center justify-center text-ink-muted hover:text-ink rounded-lg hover:bg-surface-alt transition-colors"
            aria-label="Chercher"
          >
            <SearchIcon />
          </button>

          {onBugReport && (
            <button
              type="button"
              onClick={onBugReport}
              className="md:hidden min-w-8 min-h-8 flex items-center justify-center text-ink-muted hover:text-ink rounded-lg hover:bg-surface-alt transition-colors"
              aria-label="Signaler un bug"
            >
              <BugIcon />
            </button>
          )}

          {onSettings && (
            <button
              type="button"
              onClick={onSettings}
              className="md:hidden min-w-8 min-h-8 flex items-center justify-center text-ink-muted hover:text-ink rounded-lg hover:bg-surface-alt transition-colors"
              aria-label="Paramètres"
            >
              <SettingsIcon />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
